import React, { FC } from 'react';

import { StepProps } from './Step';
import { ThreeStepSectionLarge } from './ThreeStepSectionLarge';
import { ThreeStepSectionSmall } from './ThreeStepSectionSmall';

export interface ThreeStepSectionProps {
  heading: string;
  steps: StepProps[];
  image: React.ReactNode;
}

export const ThreeStepSection: FC<ThreeStepSectionProps> = (props) => (
  <>
    <ThreeStepSectionSmall {...props} />
    <ThreeStepSectionLarge {...props} />
  </>
);
